<template>
  <div id="EvolveTask">
    <div
      class="task mt-3"
      :class="[
        task.disabled || task.completed
          ? 'bg-brand-secondary white-text'
          : 'bg-white',
        task.disabled ? 'disabled-task' : '',
        task.completed ? 'completed-task' : ''
      ]"
      @click="openTaskModal(task.id, task.title)"
    >
      <div class="fa-stack fa-1x mr-3">
        <i class="fas fa-circle fa-stack-2x" :class="getIconClass()"></i>
        <i class="fa-stack-1x fa-inverse" :class="[activeClass]"></i>
      </div>
      <div class="task-text" v-if="!task.completed">{{ task.title }}</div>
      <div v-else>
        <s
          ><div class="task-text">{{ task.title }}</div></s
        >
      </div>
      <div
        class="task-time ml-auto"
        v-if="!task.disabled"
        v-html="friendlyTaskDueDate(task)"
      ></div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  components: {},
  name: "EvolveTask",
  props: ["task"],

  mounted() {
    this.iconClass = this.task.icon
      ? this.task.icon.split('"')[1]
      : "fas fa-heart";
  },
  methods: {
    getIconClass() {
      if (this.task.completed) return "grad-icon-completed";
      if (!this.task.disabled) return "grad-icon";
      return "";
    },
    openTaskModal(id) {
      this.$emit("clicked", id, moment());
    },
    friendlyTaskDueDate(task) {
      if (task.completed) {
        return "<b>Done</b>";
      }
      if (task.recurring_type) {
        return (
          "Repeats <span class='recurrance'>" +
          task.recurring_type.charAt(0).toUpperCase() +
          task.recurring_type.slice(1) +
          "</span>"
        );
      }
      if (task.target_date !== false) {
        const testDate = moment().add(6, "days");
        const taskDate = moment(task.target_date, "YYYY-MM-DD");
        const format =
          testDate.isAfter(taskDate) && taskDate.isAfter(moment())
            ? "dddd"
            : "Do MMM";
        let output = taskDate.format(format);
        if (moment().isSame(taskDate, "day")) output = "Today";
        if (
          moment()
            .add(1, "days")
            .isSame(taskDate, "day")
        )
          output = "Tomorrow";
        return "To complete by <span class='recurrance'>" + output + "</span>";
      }
      if (task.recurring_type !== false && task.recurring_type !== undefined) {
        return (
          "Repeats <span class='recurrance'>" + task.recurring_type + "</span>"
        );
      }
      return "";
    }
  },
  computed: {
    activeClass() {
      if (this.task.completed) {
        return "fas fa-check";
      } else if (this.task.disabled) {
        return "fas fa-lock";
      } else if (this.task.icon !== null) {
        return this.task.icon.split('"')[1];
      } else {
        return "fas fa-heart";
      }
    }
  }
};
</script>
<style lang="less">
#EvolveTask {
  .recurrance {
    font-family: FilsonProBold;
  }
  .task {
    font-size: 1.4rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: nowrap;
    width: 100%;
    padding: 10px 15px;
    border-radius: 10px;
    font-weight: bold;
    z-index: 100;
    cursor: pointer;
    .task-time {
      font-family: "PlusJakartaSansRegular";
      align-self: flex-end;
      font-weight: 300;
      color: grey;
    }
    &:hover {
      .task-text {
        text-decoration: underline;
      }
    }
  }
  .task-text {
    font-family: "FilsonProBold", serif;
    background: linear-gradient(to right, #985582, #d50870);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .task.disabled-task {
    cursor: default;
    .task-text {
      font-family: "FilsonProBold", serif;
      background: #ddd;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .fa-circle {
      color: grey;
    }
    .fa-lock {
      color: white;
    }
  }
  .task.completed-task {
    background-color: #403d56;
    .task-time {
      color: white !important;
    }
    .task-text {
      font-family: "FilsonProBold", serif;
      background: white;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
  .fa-stack {
    flex-shrink: 0;
  }
}
</style>
